import { Button, Dialog, DialogActions, DialogContent, Grid } from '@mui/material';
import { MprcDialogTitleClose, MprcRequestErrorDialog, MprcRequestIndicator } from 'components';
import { ButtonCancel } from 'components/buttons';
import { useSnackbar } from 'notistack';
import { useCoreApi } from 'providers/CoreApiProvider';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
    channelId: string;
    channelName: string;
    onClose: (success: boolean) => void;
}

export const DeleteChannel: React.FC<IProps> = (props) => {

    const { channelId, channelName, onClose } = props;

    const api = useCoreApi();
    const { t } = useTranslation("knowledge");
    const { enqueueSnackbar } = useSnackbar();

    const [loading, setLoading] = useState<boolean>(false);
    const [viewError, setViewError] = useState<any>(null);

    const deleteChannel = () => {

        setLoading(true);
        api.v1.channelManagement.deleteChannel({ channelId }).then(result => {
            if (result.data === true) {
                enqueueSnackbar(t("Channel.List.DeleteChannelSuccessMessage"), {
                    variant: "success"
                });
                onClose(true);
            } else {
                enqueueSnackbar(t("Channel.List.DeleteChannelErrorMessage"), {
                    variant: "error"
                });
            }
        }).catch(e => setViewError(e))
            .finally(() => setLoading(false));

    };

    return <>
        <MprcRequestIndicator
            visible={loading} type={"post"}
        />

        <MprcRequestErrorDialog
            error={viewError}
            onClose={() => setViewError(undefined)}
        />

        <Dialog
            open
            fullWidth
            maxWidth="sm"
            onClose={() => onClose(false)}
        >
            <MprcDialogTitleClose
                title={t("Channel.List.DeleteChannelTitle")}
                subtitle={channelName}
                onClose={() => onClose(false)}
                shrinkPadding
            />
            <DialogContent>
                <Grid container direction="row" justifyContent="center" spacing={2}>
                    <Grid size={{ xs: 8 }} textAlign="center">
                        {t("Channel.List.ConfirmDeleteChannelMessageL1")}
                        <br />
                        {t("Channel.List.ConfirmDeleteChannelMessageL2")}
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "center" }}>
                <ButtonCancel variant="contained" text={t("Channel.List.NoButtonText")} onClick={() => onClose(false)} />
                <Button
                    color="error"
                    variant="contained"
                    onClick={deleteChannel}
                >
                    {t("Channel.List.YesButtonText")}
                </Button>
            </DialogActions>
        </Dialog>
    </>;
};
